// src/components/PatientNavbar.js
import React, { useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../context/AuthContext';
import { FaHome, FaCalendarPlus, FaSearch, FaUser, FaSignOutAlt } from 'react-icons/fa';
import './PatientNavbar.css';

const PatientNavbar = ({ userId }) => {
  const { patientUser, logout } = useContext(AuthContext);

  if (!userId) {
    console.error("PatientNavbar: userId is not provided");
  }

  const isAuthenticated = patientUser && patientUser.role === 'patient' && patientUser.id === userId;

  const handleNavigateToProfile = () => {
    if (isAuthenticated) {
      window.location.href = '/patient-profile';
    } else {
      window.location.href = '/login?type=patient';
    }
  };

  const handleRedirectHome = () => {
    if (isAuthenticated) {
      window.location.href = `/patient-dashboard/${patientUser.id}`;
    } else {
      window.location.href = '/login?type=patient';
    }
  };

  const handleNavigateToBookAppointment = () => {
    if (isAuthenticated) {
      window.location.href = '/book-appointment';
    } else {
      window.location.href = '/login?type=patient';
    }
  };

  const handleNavigateToSearchDoctor = () => {
    if (isAuthenticated) {
      window.location.href = '/search-doctor';
    } else {
      window.location.href = '/login?type=patient';
    }
  };

  const handleLogout = async () => {
    try {
      await axios.post('https://turemedicine-backend-1.onrender.com/api/auth/logout', {}, {
        headers: {
          Authorization: `Bearer ${patientUser?.accessToken}`,
        },
      });
      logout('patient');
      window.location.href = '/login?type=patient';
    } catch (error) {
      console.error('Logout failed:', error);
      logout('patient');
      window.location.href = '/login?type=patient';
    }
  };

  return (
    <div className="pat-nav-container">
      <button onClick={handleRedirectHome}>
        <FaHome className="pat-nav-icon" />
        <span>Home</span>
      </button>
      <button onClick={handleNavigateToBookAppointment}>
        <FaCalendarPlus className="pat-nav-icon" />
        <span>Book Appointment</span>
      </button>
      <button onClick={handleNavigateToSearchDoctor}>
        <FaSearch className="pat-nav-icon" />
        <span>Search Doctor</span>
      </button>
      <button onClick={handleNavigateToProfile}>
        <FaUser className="pat-nav-icon" />
        <span>Profile</span>
      </button>
      {isAuthenticated && (
        <button onClick={handleLogout}>
          <FaSignOutAlt className="pat-nav-icon" />
          <span>Logout</span>
        </button>
      )}
    </div>
  );
};

export default PatientNavbar;